import { ColumnTypes, LameHeadsColumnKey } from 'models'
import { LicensesType } from 'models/IUserData'

export const initialLameHeadsColumns: ColumnTypes[] = [
	{
		key: LameHeadsColumnKey.GROUP,
		title: 'Группа',
		isShowColumn: true,
	},
	{
		key: LameHeadsColumnKey.LIMPNESS,
		title: 'Хромота, балл',
		isShowColumn: true,
	},
	{
		key: LameHeadsColumnKey.LIMPNESS_LENGTH,
		title: 'Продолжительность',
		isShowColumn: true,
	},
	{
		key: LameHeadsColumnKey.LIMPNESS_CHANGE_DT,
		title: 'Последний замер',
		isShowColumn: true,
	},
	{
		key: LameHeadsColumnKey.COW_AGE,
		title: 'Возраст коровы',
		isShowColumn: false,
		requiresMilkYield: true,
	},
	{
		key: LameHeadsColumnKey.LACTATION_DAY,
		title: 'День лактации',
		isShowColumn: false,
		requiresMilkYield: true,
	},
	{
		key: LameHeadsColumnKey.FATNESS,
		title: 'Упитанность, балл',
		isShowColumn: false,
		requiresLicense: LicensesType.FATNESS,
	},
]

export const LAME_HEADS_MIN_SELECTED_COLUMNS = 1
export const LAME_HEADS_MAX_SELECTED_COLUMNS = 7
